import { createContext, useContext, useEffect, useState, useCallback } from "react";

const AuthCtx = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL;

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const r = await fetch(`${API}/api/auth/me`, { credentials: "include" });
            if (!r.ok) throw new Error("not auth");
            const u = await r.json();
            setUser(u);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip /me — AuthCallback handles it
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const logout = async () => {
        try {
            await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
        } catch (e) {
            // ignore
        }
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, checkAuth, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
